export default "__VITE_ASSET__wiZD3ooK__"